<template>
  <div class="login-container">
    <div
      style="width: 100vw; text-align: center; padding-top: 10vh; height: 25vh"
    >
      <img src="../assets/login.png" alt="" srcset="" />
    </div>
    <div
      style="
        width: calc(100vw - 60px);
        margin: 0 10px;
        height: calc(65vh - 50px);
        background-color: #fff;
        border-radius: 10px;
        padding: 20px;
      "
    >
      <p
        style="
          font-size: 30px;
          text-align: center;
          font-weight: bold;
          letter-spacing: 1px;
        "
      >
        <span style="color: #2eb16e">Question</span>
        <span>naire</span>
      </p>
      <van-form @submit="onSubmit" class="test">
        <van-field
          v-model="username"
          name="username"
          label="用户名"
          placeholder="请输入用户名"
          required
          :rules="[{ required: true, message: '请输入用户名' }]"
        />
        <van-field
          v-model="password"
          name="password"
          type="password"
          label="密码"
          placeholder="请输入密码"
          required
          :rules="[{ required: true, message: '请输入密码' }]"
        />
        <div
          class="login-button"
          style="
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 30px;
          "
        >
          <van-button
            type="primary"
            native-type="submit"
            block
            size="middle"
            style="background-color: #2eb16e; height: 38px; border-radius: 5px"
          >
            登 录
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { Toast } from 'vant';

  export default {
    name: 'LoginComponent',
    data() {
      return {
        username: '',
        password: '',
      };
    },
    methods: {
      onSubmit(values) {
        // 这里可以添加登录逻辑，例如调用后端 API 进行登录验证
        console.log('用户名:', this.username);
        console.log('密码:', this.password);

        let obj = {
          username: this.username,
          password: this.password,
        };

        axios
          .post('https://vet-phone.portolanalytica.cn/api/vetSurvey/login', obj)
          .then((response) => {
            console.log(123);
            this.$router.push('/');
          })
          .catch(function (error) {
            console.log(error);
            Toast.fail('账号或密码错误');
          });
      },
    },
  };
</script>

<style scoped>
  .login-container {
    height: 100vh;
    /* 渐变 */
    background: linear-gradient(to bottom, #43c17e 10%, #dbdee4 40%);
  }
  .login-button {
    width: 80%;
    margin-top: 20px;
  }

  .van-field__control {
    text-align: left;
  }
  /* .van-form{
    height: 100%;
    display: flex;
    flex-direction: column;
  } */

  .van-cell {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }
</style>

<style>
  .van-field--error .van-field__control,
  .van-field--error .van-field__control::placeholder {
    color: #ccc !important;
  }
  .van-field__error-message {
    text-align: right !important;
  }
  .test .van-field__label {
    margin-bottom: 12px;
  }
</style>
